export default __webpack_public_path__ + "static/next-chapter-for-eocp-cc5ee13cfce28f286aeb2bb7ccedacf4.jpg";